import { updateBankDetail } from './states';

export const services = {
  updateBankDetail,
};
